<template>
  <div>
    <div class="row">
      <div class="col s12">
        <div class="row"></div>
        <div class="row">
          <div class="col s4">
            <div class="z-depth-1 white" style="padding: 15px;">
              <InfoColumn title="Info" :data="info" />
            </div>
          </div>
          <div class="col s8">
            <div class="row">
              <div class="col s6">
                <div class="z-depth-1 white" style="padding: 15px;">
                  <InfoColumn title="Status" :data="status" />
                </div>
              </div>
              <div class="col s6">
                <div class="z-depth-1 white" style="padding: 15px;">
                  <div class="row header">
                    <div class="col s12">
                      <span class="title">Links</span>
                    </div>
                  </div>
                  <div
                    v-for="link in links"
                    class="row s12 content"
                    :key="link.url"
                  >
                    <div class="col s12">
                      <a :href="link.url">{{ link.label }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col s12">
                <div class="white" style="height: 350px; padding: 10px">
                  <DashboardMap :rail-objects="[railObject]" :last-updated="lastUpdated" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import InfoColumn from '../../components/switch/InfoColumn'
import MeasurementsApi from '../../services/api/switch/MeasurementsApi'
import DashboardMap from '../dashboard/DashboardMap'
import MaintenanceStatusService from '@/services/MaintenanceStatusService'

export default {
  name: 'SwitchInfo',
  props: {
    railObject: {
      type: Object,
      default: () => {
      }
    },
    childObjects: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  components: {DashboardMap, InfoColumn},
  data () {
    return {
      lastAlarmMeasurement: null,
      lastUpdated: new Date(),
      maintenanceStatus: null
    }
  },
  created: function () {
    this.load()
  },
  computed: {
    info () {
      if (!this.railObject) {
        return []
      } else {
        return [
          {
            label: 'Object type',
            value: this.format(this.railObject.ObjectCodeDescription)
          },
          {
            label: 'Object ID',
            value: this.format(this.railObject.RailObjectId)
          },
          {
            label: 'Object name',
            value: this.format(this.railObject.Name)
          },
          {
            label: 'External ID',
            value: this.format(this.railObject.ExternalId)
          },
          {
            label: 'Power supply',
            disabled: true
          },
          {
            label: 'Asset type',
            value: this.formatType(this.railObject.Name)
          },
          {
            label: 'Tangent',
            disabled: true
          },
          {
            label: 'Description',
            value: 'description',
            disabled: true
          },
          {
            label: 'Details',
            value: 'details',
            disabled: true
          },
          {
            multiple: true,
            label: 'Related Components',
            list: this.children.map(c => ({ value: c.Name + (c.ExternalId ? ': ( ' + c.ExternalId + ' )' : '') }))
          },
          {
            label: 'GEOCode',
            value: 'geoCode',
            disabled: true
          },
          {
            label: 'GPS',
            value: this.railObjectCoordinatesString()
          }
        ]
      }
    },
    status () {
      if (!this.railObject) {
        return []
      } else {
        return [
          {
            label: 'Monitor status',
            value: this.monitorstatusDescription
          },
          {
            label: 'Operational status',
            value: this.operationalStatusDescription
          },
          {
            label: 'Last alarm',
            value: this.lastAlarmMeasurement ? moment(this.lastAlarmMeasurement.MeasurementDateTime).format('DD-MM-YYYY HH:mm') : ''
          },
          {
            label: 'Last maintenance date',
            value: (this.maintenanceStatus !== null && this.maintenanceStatus.LastMaintDateTime !== null) ? moment(this.maintenanceStatus.LastMaintDateTime).format('DD-MM-YYYY HH:mm') : ''
          },
          {
            label: 'Next maintenance date',
            value: (this.maintenanceStatus !== null && this.maintenanceStatus.nextMaintDate !== null) ? moment(this.maintenanceStatus.nextMaintDate).format('DD-MM-YYYY HH:mm') : ''
          },
          {
            label: 'Movements since maintenance',
            value: (this.maintenanceStatus !== null && this.maintenanceStatus.ActualMovements !== null) ? this.maintenanceStatus.ActualMovements : ''
          },
          {
            parent: true,
            label: 'Maintenance',
            children: [
              {
                label: 'Last',
                value: this.lastMaintenanceDateTime
              },
              {
                label: 'Next',
                value: 'nextMaintenance',
                disabled: true
              }
            ]
          }
        ]
      }
    },
    links () {
      return [
        // {url: '#a', label: 'A'},
        // {url: '#b', label: 'B'},
        // {url: '#c', label: 'C'}
      ]
    },
    monitorstatusDescription () {
      if (this.railObject) {
        switch (this.railObject.MonitorStatusId) {
          case 1:
            return this.$t('ok')
          case 2:
            return this.$t('warning')
          case 3:
            return this.$t('error')
          default:
            return this.$t('unknown')
        }
      } else {
        return this.$t('unknown')
      }
    },
    operationalStatusDescription () {
      if (this.railObject) {
        switch (this.railObject.OperationModeId) {
          case 1:
            return this.$t('operational')
          case 5:
            return this.$t('maintenance')
          default:
            return this.$t('operational')
        }
      } else {
        return this.$t('unknown')
      }
    },
    lastMaintenanceDateTime () {
      if (this.railObject) {
        if (this.railObject.LastMaintenanceDateTime) {
          return moment(this.railObject.LastMaintenanceDateTime).format('YYYY-MM-DD')
        } else {
          return this.$t('unknown')
        }
      } else {
        return this.$t('unknown')
      }
    },
    children () {
      return this.childObjects[0] ? this.childObjects[0].childObjects : []
    }
  },
  watch: {
    railObject () {
      this.load()
    }
  },
  methods: {
    load () {
      this.getLastAlarm()
      this.lastUpdated = new Date()
      this.getMaintenanceStatus()
    },
    getMaintenanceStatus: async function () {
      await MaintenanceStatusService.GetMaintenanceStatus(this.railObject.ComplexId).then(result => {
        for (let i = 0; i < result.length; i++) { // Find the right object in the array
          if (result[i].RailObjectID === this.railObject.RailObjectId) {
            this.maintenanceStatus = result[i]
            break
          }
        }
      })
    },
    format (value) {
      return value !== null ? value : this.$t('unknown')
    },
    formatType (value) {
      if (value === null) {
        return this.$t('unknown')
      }
      let start = value.indexOf('(')
      let end = value.indexOf(')')
      if (start !== null && end !== null && end > start) {
        return value.substring(start + 1, end)
      }
      /* default to unkonwn */
      return this.$t('unknown')
    },
    getLastAlarm: async function () {
      await MeasurementsApi.getLastAlarm(this.railObject.RailObjectId, 1)
        .then(r => {
          this.lastAlarmMeasurement = r.data
        })
    },
    railObjectCoordinatesString () {
      if (this.railObject) {
        if (this.railObject.Latitude && this.railObject.Longtitude) {
          return this.railObject.Latitude.toString() + ', ' + this.railObject.Longtitude.toString()
        } else {
          return this.$t('unknown')
        }
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
  .title {
    padding-left: 15px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px !important;
    color: rgba(0, 0, 0, 0.87);
  }

  .property {
    text-align: right;
    font-weight: bold;
  }

  .disabled {
    color: lightgrey;
  }

  .content {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/switch/SwitchInfo.vue